import React from 'react';
import { Dialog, IconButton, Box, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  open: boolean;
  onClose: () => void;
  mediaUrl: string;
  mediaType: 'image' | 'video';
}

export const CommunityMediaLightbox: React.FC<Props> = ({
  open,
  onClose,
  mediaUrl,
  mediaType,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth={false}
      PaperProps={{ sx: { bgcolor: '#000', m: 0, maxWidth: '100%' } }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'fixed',
          top: 12,
          right: 12,
          color: '#fff',
          zIndex: 1400,
          bgcolor: 'rgba(0,0,0,0.45)',
          '&:hover': { bgcolor: 'rgba(0,0,0,0.65)' },
        }}
        aria-label="Close preview"
      >
        <CloseIcon />
      </IconButton>
      <Box
        sx={{
          width: isMobile ? '100vw' : 'min(96vw, 960px)',
          height: isMobile ? '100vh' : 'min(90vh, 720px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        {mediaType === 'video' ? (
          <Box
            component="video"
            src={mediaUrl}
            controls
            autoPlay
            sx={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        ) : (
          <Box
            component="img"
            src={mediaUrl}
            alt="Media preview"
            sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        )}
      </Box>
    </Dialog>
  );
};
